<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <l-data-table
      :headers="(ruleListType==='simple')?header_simple:header_period"
      title-text="计费规则列表"
      search-text="请输入规则名称"
      @click:row="getDetails($event.item)"
      clickable
      ref="ruleList"
      :get-data-func="(ruleListType==='simple')?getRuleConfigList:getPeriodConfigList">
        <template slot="title">
          <span class="pl-2 pr-4">计费规则列表</span>
          <v-radio-group mandatory row v-model="ruleListType">
            <v-radio :value="'simple'" label="简单规则"></v-radio>
            <v-radio :value="'period'" label="周期规则"></v-radio>
          </v-radio-group>
        </template>
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center">
            <v-tooltip left>
              <v-btn @click="(ruleListType==='simple')?deleteSimpleRuleConfirm(item):deletePeriodRuleConfirm(item)" slot="activator" icon>
                <v-icon small>$vuetify.icons.delete</v-icon>
              </v-btn>
              <span>删除配置</span>
            </v-tooltip>
          </td>
        </template>
      </l-data-table>
      <l-fixed-btn
        @click="addRule"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </v-card>
  </l-layout>
</template>
<script>
import LDataTable from '../../../ladmin/components/LDataTable/LDataTable'
import {time} from '../../../ladmin/utils/time'
export default{
  name: 'ruleConfigList',
  components: {LDataTable},
  data () {
    return {
      header_simple: [
        {text: '规则名称', value: 'name', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', sortable: true, f: (v) => time.stringify(new Date(v))},
        {text: '创建人', value: 'creator', align: 'left', sortable: false},
        {text: '规则状态', value: 'status', align: 'left', sortable: false},
        {text: '', value: '', align: 'left', sortable: false},
      ],
      header_period: [
        {text: '规则名称', value: 'name', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', sortable: true, f: (v) => time.stringify(new Date(v))},
        {text: '创建人', value: 'creator', align: 'left', sortable: false},
        {text: '规则状态', value: 'status', align: 'left', sortable: false},
        {text: '', value: '', align: 'left', sortable: false},
      ],
      ruleListType: 'simple'
    }
  },
  methods: {
    async getRuleConfigList ({pagination, sortStack, filterItems, search}) {
      let {items, amount} = await this.$store.dispatch('charging/getRuleConfigList', {pagination, sortStack, filterItems, search: {key: 'name', value: search}})
      return {items, amount}
    },
    async getPeriodConfigList ({pagination, sortStack, filterItems, search}) {
      let {items, amount} = await this.$store.dispatch('charging/getPeriodConfigList', {pagination, sortStack, filterItems, search: {key: 'name', value: search}})
      return {items, amount}
    },
    addRule () {
      this.$router.push({name: 'newRuleConfig', query: {id: 'newRuleConfig', status: 'new', type: ''}})
    },
    getDetails (item) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({name: 'ruleConfig', query: {id: item.id, status: 'readonly', type: this.ruleListType}})
      }
    },
    async deleteSimpleRuleConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该模板？',
        text: '规则名称:' + item.name
      })
      if (res) {
        try {
          await this.deleteSimpleRule(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteSimpleRule (item) {
      let res = await this.$store.dispatch('charging/deleteSimpleRule', item.id)
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.ruleList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
      }
    },
    async deletePeriodRuleConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该模板？',
        text: '规则名称:' + item.name
      })
      if (res) {
        try {
          await this.deletePeriodRule(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deletePeriodRule (item) {
      let res = await this.$store.dispatch('charging/deletePeriodRule', item.id)
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.ruleList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
      }
    },
  }
}
</script>
